import React, { useEffect, useMemo } from 'react';
import { TEXT_DIRECTION } from 'helpers/isRtlLanguage';

import { Slider } from '@atlas/components';
import { SiteConfigManager, useCasinoNewState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { CASINO_TILE_TYPES } from '@atlas/ui';

import InfoGame from 'components/Casino/components/InfoGame';
import { GAME_SIZES } from 'components/Casino/constants';
import { useIsRtl } from 'hooks/useIsRtl';

const { CASINO } = COMPONENT_TYPES;
const SmarticoRecommendedGames = ({ relatedGames, setSwiper }) => {
  const casinoPath = SiteConfigManager.getComponentPath(CASINO, 'casino');
  const casinoGameTileType = SiteConfigManager.getConfig(
    'config.config.general.desktopCasinoGameTileView',
    CASINO_TILE_TYPES.TYPE_5,
  );
  const isRtl = useIsRtl();
  const dir = useMemo(() => (isRtl ? TEXT_DIRECTION.RTL : TEXT_DIRECTION.LTR), [isRtl]);

  const slidesPerView = useMemo(() => {
    if (casinoGameTileType === CASINO_TILE_TYPES.TYPE_5) {
      return 2.6;
    }

    return 2.375;
  }, [casinoGameTileType]);

  const { identifyFavoriteGames } = useCasinoNewState();
  useEffect(() => {
    if (!relatedGames.length) return;

    const gameIds = relatedGames.map(({ id }) => id);

    identifyFavoriteGames(gameIds);
  }, [relatedGames, identifyFavoriteGames]);

  return (
    <Slider
      autoplay={false}
      breakpointsBase="container"
      className="casino__slider-games"
      dir={dir}
      loop={false}
      onBeforeInit={setSwiper}
      slidesPerView={slidesPerView}
      spaceBetween={8}
    >
      {relatedGames.map(game => (
        <Slider.Slide key={game.id}>
          <InfoGame
            game={game}
            gameBasePathname={casinoPath}
            gameItemClass="game"
            size={GAME_SIZES.SMALL}
          />
        </Slider.Slide>
      ))}
    </Slider>
  );
};

export default SmarticoRecommendedGames;
